<script setup>
import { Handle, Position } from '@vue-flow/core';
import { NODE_TYPES } from '../../constants';
import FlowNodeCard from './FlowNodeCard.vue';

defineProps({ selected: { type: Boolean, default: false } });
const meta = NODE_TYPES.start;
</script>

<template>
  <FlowNodeCard :icon="meta.icon" :color="meta.color" :title="meta.label" :selected="selected">
    <span>Começo da conversa.</span>
    <Handle type="source" :position="Position.Right" />
  </FlowNodeCard>
</template>
